export type SortOption = "title" | "area" | "owner" | "targetGroups" | "lastChanged";
export type SortDirection = "asc" | "desc";

export const defaultSortOption: SortOption = "title";
export const defaultSortDirectionByOption: Record<SortOption, SortDirection> = {
    title: "asc",
    area: "asc",
    owner: "asc",
    targetGroups: "asc",
    lastChanged: "desc",
};

export const sortOptionValues = new Set<SortOption>(["title", "area", "owner", "targetGroups", "lastChanged"]);

export function getDefaultSortDirectionForOption(sortOption: SortOption): SortDirection {
    return defaultSortDirectionByOption[sortOption];
}

export const searchQueryParamKey = "q";
export const sortQueryParamKey = "sort";
export const sortDirectionQueryParamKey = "dir";
export const areaQueryParamKey = "area";
export const ownerQueryParamKey = "owner";
export const targetGroupQueryParamKey = "targetGroup";

export const lastChangedFieldLabel = "sist endring";
